import React from 'react';
import { Direction } from '@prisjakt/ui';
import { Dropdown, DropdownContent } from '@prisjakt/ui/dropdown';
import { Behavior } from '@prisjakt/ui/text';
import { zindex } from 'src/ui/zindex';
import { ColorVariantsButtonLabel } from './color-variants-button-label';
import { ColorVariantsGrid } from './color-variants-grid';
import { IVariantsProps } from '../types';
import { DropdownToggle, DropdownButtonText } from '../styles';

export const ColorVariantsDesktopVersion: React.FC<IVariantsProps> = props => {
  return (
    <Dropdown zIndex={zindex.overlay}>
      <DropdownToggle showActiveIcon fullWidth>
        <DropdownButtonText behavior={Behavior.OnelineEllipsis}>
          <ColorVariantsButtonLabel />
        </DropdownButtonText>
      </DropdownToggle>
      <DropdownContent alignment={Direction.Down}>
        <ColorVariantsGrid {...props} />
      </DropdownContent>
    </Dropdown>
  );
};
